import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

// Страницы пользователя
import HomePage from '../pages/HomePage.vue';
import LoginPage from '../pages/LoginPage.vue';
import RegisterPage from '../pages/RegisterPage.vue';
import ServicesPage from '../pages/ServicesPage.vue';
import CreateOrderPage from '../pages/CreateOrderPage.vue';
import OrdersPage from '../pages/OrdersPage.vue';
import OrderDetailPage from '../pages/OrderDetailPage.vue';
import ProfilePage from '../pages/ProfilePage.vue';

// Админ
import AdminLayout from '../AdminLayout.vue';
import AdminDashboard from '../pages/admin/AdminDashboard.vue';
import AdminServices from '../pages/admin/AdminServices.vue';
import AdminOrders from '../pages/admin/AdminOrders.vue';
import AdminOrderDetail from '../pages/admin/AdminOrderDetail.vue';
import AdminUsers from '../pages/admin/AdminUsers.vue';
import AdminReports from '../pages/admin/AdminReports.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
    meta: { requiresGuest: true }
  },
  {
    path: '/services',
    name: 'Services',
    component: ServicesPage
  },
  {
    path: '/orders/create',
    name: 'CreateOrder',
    component: CreateOrderPage,
    // BUG FIX: убрали requiresAuth — чтобы неавторизованные тоже могли оформлять
  },
  {
    path: '/orders',
    name: 'Orders',
    component: OrdersPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/:id',
    name: 'OrderDetail',
    component: OrderDetailPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: { requiresAuth: true }
  },
  // BUG FIX: добавлен алиас для старого пути OrderCreatePage
  {
    path: '/order/new',
    redirect: '/orders/create'
  },

  // Админ маршруты
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      { path: '', name: 'AdminDashboard', component: AdminDashboard },
      { path: 'services', name: 'AdminServices', component: AdminServices },
      { path: 'orders', name: 'AdminOrders', component: AdminOrders },
      { path: 'orders/:id', name: 'AdminOrderDetail', component: AdminOrderDetail },
      { path: 'users', name: 'AdminUsers', component: AdminUsers },
      { path: 'reports', name: 'AdminReports', component: AdminReports }
    ]
  },

  // 404
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Скролл наверх при переходе между страницами
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0, behavior: 'smooth' };
  }
});

// Навигационный guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // Требует авторизации
  if (to.meta.requiresAuth && !authStore.token) {
    next('/login');
    return;
  }

  // Только для неавторизованных
  if (to.meta.requiresGuest && authStore.token) {
    next('/');
    return;
  }

  // BUG FIX: Требует роль админа — теперь реально проверяем
  if (to.meta.requiresAdmin) {
    if (!authStore.token) {
      next('/login');
      return;
    }
    if (authStore.user?.role !== 'admin') {
      next('/');
      return;
    }
  }

  next();
});

export default router;
